/**
 * Secure storage for sensitive device credentials (boardId, boardCode,
 * pairing secrets).
 *
 * Backing: localStorage — works in all browsers and on Tizen OS
 * (Samsung SSSP signage displays). Data persists across app restarts;
 * it is NOT hardware-backed, but is scoped to the app origin.
 *
 * The cryptographic credential (ECDSA private key) is stored separately
 * in IndexedDB with `extractable: false` via Web Crypto — see keystore.ts.
 *
 * On Android (if we ever re-add Capacitor): swap the impl to
 * @capacitor-community/secure-storage which uses Android Keystore /
 * iOS Keychain. The interface stays the same.
 */

export const secureStorage = {
  async get(key: string): Promise<string | null> {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  async set(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
  },

  async remove(key: string): Promise<void> {
    localStorage.removeItem(key);
  },

  /** On Tizen/browser storage is not hardware-backed. */
  isHardwareBacked: false,

  /** True only when running inside a native Capacitor container. */
  isNative: false,
};
